import React, { useState } from "react";
import "./JobSub.css"; // same CSS
import jobComImg1 from "../../Images/jobComImg1.jpg";
import jobComImg2 from "../../Images/jobComImg2.jpg";
import jobComImg3 from "../../Images/jobComImg3.jpg";
import jobComImg4 from "../../Images/jobComImg4.jpg";
import Slider from "../../Components/Service Partners/Trusted";
import jobImg1 from "../../Images/jobImg1.png";
import jobImg2 from "../../Images/jobImg2.png";
import jobImg3 from "../../Images/jobImg3.png";
import jobImg4 from "../../Images/jobImg4.png";
import jobImg5 from "../../Images/jobImg5.png";
import JobMainVideo1 from "../../Images/jobMainVideo4.mp4";

const WorldwideJobsSub = () => {
  const jobs = [
    {
      id: 1,
      img: jobComImg1,
      title: "Frontend Developer",
      location: "New York, USA",
      mode: "Remote",
      skills: "React | JavaScript | HTML | CSS",
    },
    {
      id: 2,
      img: jobComImg2,
      title: "Backend Developer",
      location: "London, UK",
      mode: "OnSite",
      skills: "Node.js | Express | MongoDB",
    },
    {
      id: 3,
      img: jobComImg3,
      title: "UX Designer",
      location: "Berlin, Germany",
      mode: "Remote",
      skills: "Figma | Adobe XD | Prototyping",
    },
    {
      id: 4,
      img: jobComImg4,
      title: "Data Scientist",
      location: "Toronto, Canada",
      mode: "Remote",
      skills: "Python | Machine Learning | SQL",
    },
    {
      id: 5,
      img: jobComImg1,
      title: "Cloud Engineer",
      location: "Sydney, Australia",
      mode: "OnSite",
      skills: "AWS | Azure | Docker | Kubernetes",
    },
  ];

  const [openFilter, setOpenFilter] = useState(null);
  const [selectedTitles, setSelectedTitles] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedModes, setSelectedModes] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState(jobs);

  const toggleDropdown = (filterName) => {
    setOpenFilter(openFilter === filterName ? null : filterName);
  };

  const handleCheckbox = (value, selectedList, setSelectedList) => {
    if (selectedList.includes(value)) {
      setSelectedList(selectedList.filter((item) => item !== value));
    } else {
      setSelectedList([...selectedList, value]);
    }
  };

  const handleSearch = () => {
    let result = jobs.filter((job) => {
      const titleMatch =
        selectedTitles.length === 0 || selectedTitles.includes(job.title);
      const locationMatch =
        selectedLocations.length === 0 ||
        selectedLocations.includes(job.location);
      const modeMatch =
        selectedModes.length === 0 || selectedModes.includes(job.mode);

      return titleMatch && locationMatch && modeMatch;
    });
    setFilteredJobs(result);
  };

  return (
    <div className="jobSubSection">
      <div className="jobHero">
        <video width="100%" height="100%" autoPlay muted loop>
          <source src={JobMainVideo1} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="jobHeroCover">
          <div className="jobHeroText">
            <h1>Search Worldwide Jobs</h1>
          </div>
          <div className="jobFilter">
            <div className="jobSubFilter">
              <div onClick={() => toggleDropdown("title")}>Job Title</div>
              <div onClick={() => toggleDropdown("location")}>Location</div>
              <div onClick={() => toggleDropdown("mode")}>Job Mode</div>
              <button onClick={handleSearch}>Search</button>
            </div>

            {/* Job Title Dropdown */}
            {openFilter === "title" && (
              <div className="jobTitleDropDown">
                {jobs.map((job) => (
                  <div key={job.id}>
                    <input
                      type="checkbox"
                      checked={selectedTitles.includes(job.title)}
                      onChange={() =>
                        handleCheckbox(job.title, selectedTitles, setSelectedTitles)
                      }
                    />
                    <label>{job.title}</label>
                  </div>
                ))}
              </div>
            )}

            {/* Location Dropdown */}
            {openFilter === "location" && (
              <div className="jobLocationDropDown">
                {[...new Set(jobs.map((job) => job.location))].map((loc) => (
                  <div key={loc}>
                    <input
                      type="checkbox"
                      checked={selectedLocations.includes(loc)}
                      onChange={() =>
                        handleCheckbox(loc, selectedLocations, setSelectedLocations)
                      }
                    />
                    <label>{loc}</label>
                  </div>
                ))}
              </div>
            )}

            {/* Job Mode Dropdown */}
            {openFilter === "mode" && (
              <div className="jobModeDropDown">
                {[...new Set(jobs.map((job) => job.mode))].map((mode) => (
                  <div key={mode}>
                    <input
                      type="checkbox"
                      checked={selectedModes.includes(mode)}
                      onChange={() =>
                        handleCheckbox(mode, selectedModes, setSelectedModes)
                      }
                    />
                    <label>{mode}</label>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="jobSubSearch">
        <div className="jobSubSearchBlock">
          {filteredJobs.length > 0 ? (
            filteredJobs.map((job) => (
              <div className="jobSubCard" key={job.id}>
                <div className="jobSubImg">
                  <img src={job.img} alt={job.title} />
                  <h3>{job.title}</h3>
                </div>
                <div className="jobSubText">
                  <p>{job.skills}</p>
                  <p>Location: {job.location}</p>
                  <p>Job Mode: {job.mode}</p>
                  <div className="jobSubText2">
                    <span>5L - 12L</span>
                    <span>0 - 5 years</span>
                    <button>
                      <a href="/form">Apply</a>
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No jobs found</p>
          )}
        </div>
      </div>

      {/* Trending Jobs */}
      <div className="jobSubTrend">
        <h2>Trending Worldwide Jobs</h2>
        <div className="jobSubTrendBlock">
          {jobs.slice(0, 3).map((job) => (
            <div className="jobSubTrendCard" key={job.id}>
              <div className="jobSubImg">
                <img src={job.img} alt={job.title} />
                <h3>{job.title}</h3>
              </div>
              <div className="jobSubText">
                <p>{job.skills}</p>
                <p>Location: {job.location}</p>
                <div className="jobSubText2">
                  <span>5L - 12L</span>
                  <span>0 - 5 years</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Slider />

      {/* Top Talent Seekers */}
      <div className="jobSubTalent">
        <h2>Top Global Companies</h2>
        <div className="jobSubTalentBlock">
          {[jobImg1, jobImg2, jobImg3, jobImg4, jobImg5].map((img, idx) => (
            <div className="jobSubTalentCard" key={idx}>
              <div className="jobSubTalentImg">
                <img src={img} alt={`company${idx}`} />
              </div>
              <h1>
                {["Google", "Amazon", "Wipro", "Mind tree", "Adobe"][idx]}
              </h1>
              <p>{[127, 85, 35, 89, 55][idx]} openings</p>
              <div className="jobSubTalentText">
                <p>8L</p>
                <p>15L</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WorldwideJobsSub;
